import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/home/Home';
import { Lobby } from './pages/lobby/Lobby';
import { useState, useEffect } from 'react';
import { Setback } from './pages/nuSetback/setback';
import { JoinGame } from './pages/join/JoinGame';
import { V2apiClient } from './ApiClient';
import { ErrorBoundary } from './ui/ErrorBoundary';
import { ToastProvider } from './ui/Toast';

export default function App() {
  const [player, setPlayer] = useState<{ id: string; name: string }>();
  const [redirectTo, setRedirectTo] = useState<string>();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    V2apiClient.getMe()
      .then((res) => {
        if (res) {
          setPlayer(res.user);
          setRedirectTo(res.inGame ? '/setback' : '/lobby');
        }
      })
      // No session (or no server): fall through to Home rather than hanging on
      // the blank checking screen.
      .catch(() => undefined)
      .finally(() => setChecking(false));
  }, []);

  // Clearing the player sends every gated route back to Home; redirectTo has to
  // go with it, or Home would immediately bounce the user into the lobby again.
  const onLoggedOut = () => {
    setPlayer(undefined);
    setRedirectTo(undefined);
  };

  if (checking) return null;

  return (
    <ErrorBoundary>
      <ToastProvider>
        <Router>
          <Routes>
            <Route
              path="/lobby"
              element={player ? <Lobby onLoggedOut={onLoggedOut} /> : <Navigate to="/" replace />}
            />
            <Route
              path="/setback"
              element={player ? <Setback player={player} /> : <Navigate to="/" replace />}
            />
            {/* Invite-link target. Ungated: JoinGame resolves the session itself and
              redirects to Home (to register) or into the game. */}
            <Route path="/join/:code" element={<JoinGame setPlayerCallback={setPlayer} />} />
            <Route
              path="/"
              element={
                redirectTo ? (
                  <Navigate to={redirectTo} replace />
                ) : (
                  <Home setPlayerCallback={setPlayer} />
                )
              }
            />
          </Routes>
        </Router>
      </ToastProvider>
    </ErrorBoundary>
  );
}
